<template>
  <div class="p-2 p-sm-4 bg-white rounded-lg h-100 overflow-hidden">
    <DataTable />
  </div>
</template>

<script>
import DataTable from "@/own/components/fulfillment/asn/DataTable.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import { SET_ASN_PAGE_VISIBLE } from "@/core/services/store/asn.module.js";
export default {
  name: "Asn",
  components: { DataTable },

  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.$store.commit(SET_ASN_PAGE_VISIBLE, true);
  },
  beforeDestroy() {
    this.$store.commit(SET_ASN_PAGE_VISIBLE, false);
  },
};
</script>
